var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"selectedMenu":'2'}},[_c('div',{staticClass:"middle container"},[_c('AuthorList',{attrs:{"itemList":_vm.videoList,"small":true}}),_vm._v(" "),_c('pages',{attrs:{"page-size":_vm.pagerParam.pageSize,"page-count":_vm.pagerParam.pageCount,"current-page":_vm.pagerParam.currentPage,"total":_vm.pagerParam.total},on:{"current-page-changed":_vm.OnCurrentPageChanged}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bf070a6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/explore/ExploreAuth.vue
// module id = null
// module chunks = 